// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true*/
import etask from 'zetask';
// @ts-ignore
import {ajax} from 'hola_pub_util';
import storage from '/util/storage.js';
import hola_opt from 'hola_opt';

export const logout = ()=>{
    etask(function*(){
        yield ajax({url: '/users/logout/inline', type: 'POST',
            xhrFields: {withCredentials: true}});
        storage.clr_all();
        location.href = '/';
    });
};

export const use_menu_config = ()=>hola_opt.menu_config;
